import { viperApi, clinicalApiPath } from '@/services/viper-api'

export const uploadService = {
  basePath: () => `${clinicalApiPath}/upload`,

  signRequest(stringToSign, dateString, canonicalRequest) {
    return viperApi.get(
      this.basePath() +
        '/auth?toSign=' +
        stringToSign +
        '&datetime=' +
        dateString +
        '&canonicalRequest=' +
        canonicalRequest
    )
  },

  createFileUpload(fileUpload) {
    return viperApi.post(this.basePath(), fileUpload)
  },

  putFileUpload(fileUpload) {
    return viperApi.put(this.basePath() + `/${fileUpload.id}`, fileUpload)
  },

  getUploadConfig() {
    return viperApi.get(this.basePath() + '/config')
  }
}
